
import { defineComponent, reactive } from "vue";
import { initEscrow } from "./util/initEscrow";

interface EscrowState {
    escrowAccountPubkey: null | string;
    isInitialized: null | boolean;
    initializerAccountPubkey: null | string;
    XTokenTempAccountPubkey: null | string;
    initializerYTokenAccount: null | string;
    expectedAmount: null | number;
}

export default defineComponent({
  setup() {
    const formState = reactive({
      privateKey: "",
      programId: "",
      aliceXTokenAccountPubkey: "",
      aliceYTokenAccountPubkey: "",
      amountXTokensToSendToEscrow: 0,
      amountYTokensAliceExpects: 0
    })

    const escrowState: EscrowState = reactive({
      escrowAccountPubkey: null,
      isInitialized: null,
      initializerAccountPubkey: null,
      XTokenTempAccountPubkey: null,
      initializerYTokenAccount: null,
      expectedAmount: null
    });

    const resetAliceUI = () => {
      formState.privateKey = "";
      formState.programId = "";
      formState.aliceXTokenAccountPubkey = "";
      formState.aliceYTokenAccountPubkey = "";
      formState.amountXTokensToSendToEscrow = 0;
      formState.amountYTokensAliceExpects = 0;
      Object.keys(escrowState).forEach(key => escrowState[key as keyof EscrowState] = null);
    }

    const onInitEscrow = async () => {
      try {
        const { 
          escrowAccountPubkey,
          isInitialized,
          initializerAccountPubkey,
          XTokenTempAccountPubkey,
          initializerYTokenAccount,
          expectedAmount
        } = await initEscrow(
          formState.privateKey,
          formState.aliceXTokenAccountPubkey,
          formState.amountXTokensToSendToEscrow,
          formState.aliceYTokenAccountPubkey,
          formState.amountYTokensAliceExpects,
          formState.programId
        );
        escrowState.escrowAccountPubkey = escrowAccountPubkey;
        escrowState.isInitialized = isInitialized;
        escrowState.initializerAccountPubkey = initializerAccountPubkey;
        escrowState.XTokenTempAccountPubkey = XTokenTempAccountPubkey;
        escrowState.initializerYTokenAccount = initializerYTokenAccount;
        escrowState.expectedAmount = expectedAmount;
      } catch(err) {
        if (err instanceof Error) {
          alert(err.message);
        } else {
          alert("A message-less error occurred");
        }
      }
    }

    return {
      formState,
      resetAliceUI,
      onInitEscrow,
      escrowState
    }
  }
})
